import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navItemDefaultVariants = {}
const navItemCompoundVariants = []

const navItemSlotNames = [
  [
    "root",
    "nav-item__root"
  ],
  [
    "iconWrapper",
    "nav-item__iconWrapper"
  ],
  [
    "text",
    "nav-item__text"
  ]
]
const navItemSlotFns = /* @__PURE__ */ navItemSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navItemDefaultVariants, getSlotCompoundVariant(navItemCompoundVariants, slotName))])

const navItemFn = memo((props = {}) => {
  return Object.fromEntries(navItemSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navItemVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...navItemDefaultVariants, ...compact(variants) })

export const navItem = /* @__PURE__ */ Object.assign(navItemFn, {
  __recipe__: false,
  __name__: 'navItem',
  raw: (props) => props,
  variantKeys: navItemVariantKeys,
  variantMap: {
  "size": [
    "1",
    "2"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, navItemVariantKeys)
  },
  getVariantProps
})